module.exports = __webpack_public_path__ + "img/help-title-en_ef70d55c8.png";